<h5 mat-dialog-title i18n>Select Print Options</h5>
<div mat-dialog-content>
  <p i18n>Select options for printing.</p>
  <form #printOptionsForm="ngForm" (ngSubmit)="printReport()">
    <div class="form-group">
      <select name="locale" class="form-control select-bidit" [(ngModel)]="locale">
        <option value="en">English</option>
        <option value="es">Español</option>
      </select>
    </div>
    <div class="form-group float-right">
      <button type="submit" mat-button class="btn btn-bidit-action mr-1" i18n>Print</button>
      <button type="button" mat-button (click)="onNoClick()" class="btn btn-bidit-cancel" i18n>Cancel</button>
    </div>
    <app-spinner [isRunning]="isRequesting"></app-spinner>
  </form>
</div>
